import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { transactionLineChart } from "../../api";

function TransactionLineChart({ selectedYear, selectedMonth, powerappId }) {
    const [noData, setNoData] = useState(true);
    const [series, setSeries] = useState([
        {
            name: "Desktops",
            data: [10, 41, 35, 51, 49, 62, 69, 91, 148],
        },
    ]);

    const [options, setOptions] = useState({
        chart: {
            height: 350,
            type: "line",
            zoom: {
                enabled: false,
            },
            toolbar: {
                show: false,
            },
        },
        dataLabels: {
            enabled: false,
        },
        stroke: {
            curve: "straight",
        },
        title: {
            text: "Transaction Trends by Month",
            align: "left",
        },
        grid: {
            row: {
                colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
                opacity: 0.5,
            },
        },
        xaxis: {
            categories: [
                "Jan",
                "Feb",
                "Mar",
                "Apr",
                "May",
                "Jun",
                "Jul",
                "Aug",
                "Sep",
            ],
        },
    });

    const [chartFilter, setChartFilter] = useState("by_days");

    useEffect(() => {
        transactionLineChart({
            powerapp_id: powerappId,
            year: selectedYear,
            month: selectedMonth,
            chart_filter: chartFilter,
        }).then((res) => {
            setSeries([
                {
                    name: "Transaction Amount",
                    data: res.data,
                },
            ]);

            setOptions({
                chart: {
                    height: 350,
                    type: "line",
                    zoom: {
                        enabled: false,
                    },
                    toolbar: {
                        show: false,
                    },
                },
                dataLabels: {
                    enabled: false,
                },
                stroke: {
                    curve: "straight",
                },
                title: {
                    text: `Transaction Trends by ${selectedMonth == null ? "Month" : "Day"}`,
                    align: "left",
                },
                grid: {
                    row: {
                        colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
                        opacity: 0.5,
                    },
                },
                xaxis: {
                    categories: res.categories,
                },
            });

            const sum = res.data.reduce(
                (accumulator, currentValue) => +accumulator + +currentValue,
                0,
            );
            if (sum > 0) {
                setNoData(false);
            } else {
                setNoData(true);
            }
        });
    }, [selectedYear, selectedMonth, chartFilter]);

    return (
        <div>
            {noData ? (
                <h6>No Data</h6>
            ) : (
                <>
                    {selectedMonth !== null && (
                        <div className="btn-grp-filter">
                            <button
                                type="button"
                                onClick={() => setChartFilter("by_weeks")}
                                className="btn btn-sm"
                            >
                                By Weeks
                            </button>
                            <button
                                type="button"
                                onClick={() => setChartFilter("by_days")}
                                className="btn btn-sm"
                            >
                                By Days
                            </button>
                        </div>
                    )}
                    <ReactApexChart
                        options={options}
                        series={series}
                        type="line"
                        height={350}
                    />
                </>
            )}
        </div>
    );
}

export default TransactionLineChart;
